import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ro',
  months: [
    'ianuarie',
    'februarie',
    'martie',
    'aprilie',
    'mai',
    'iunie',
    'iulie',
    'august',
    'septembrie',
    'octombrie',
    'noiembrie',
    'decembrie',
  ],
  monthsShort: ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'noi', 'dec'],
  weekdays: ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'],
  weekdaysMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  weekdaysShort: ['Dum', 'Lu', 'Ma', 'Mi', 'Joi', 'Vi', 'Sâm'],
  formats: {
    LT: 'H:mm',
    LTS: 'HH:mm:ss',
    lt: 'H:mm',
    lts: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, H:mm',
    'LLL-Y': 'D MMMM, H:mm',
    LLLL: 'dddd, D MMMM YYYY, H:mm',
    'LLLL-Y': 'dddd D MMMM, H:mm',
    l: 'DD.MM.YYYY',
    'l-Y': 'DD.MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, H:mm',
    'lll-Y': 'D MMM, H:mm',
    llll: 'ddd, D MMM YYYY, H:mm',
    'llll-Y': 'ddd, D MMM, H:mm',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, H:mm ([GMT]Z)',
  },
  meridiem: { am: 'a.m.', pm: 'p.m.', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: 'acum %s an', few: 'acum %s ani', other: 'acum %s de ani' },
    M: { one: 'acum %s lună', few: 'acum %s luni', other: 'acum %s luni' },
    w: { one: 'acum %s săpt.', few: 'acum %s săpt.', other: 'acum %s săpt.' },
    d: { one: 'acum %s zi', few: 'acum %s zile', other: 'acum %s de zile' },
    h: { one: 'acum %s h', few: 'acum %s h', other: 'acum %s h' },
    m: { one: 'acum %s min.', few: 'acum %s min.', other: 'acum %s min.' },
    s: { one: 'acum %s sec.', few: 'acum %s sec.', other: 'acum %s sec.' },
  },
  future: {
    y: { one: 'peste %s an', few: 'peste %s ani', other: 'peste %s de ani' },
    M: { one: 'peste %s lună', few: 'peste %s luni', other: 'peste %s luni' },
    w: { one: 'peste %s săpt.', few: 'peste %s săpt.', other: 'peste %s săpt.' },
    d: { one: 'peste %s zi', few: 'peste %s zile', other: 'peste %s de zile' },
    h: { one: 'peste %s h', few: 'peste %s h', other: 'peste %s h' },
    m: { one: 'peste %s min.', few: 'peste %s min.', other: 'peste %s min.' },
    s: { one: 'peste %s sec.', few: 'peste %s sec.', other: 'peste %s sec.' },
  },
  pastLong: {
    y: { one: 'acum %s an', few: 'acum %s ani', other: 'acum %s de ani' },
    M: { one: 'acum %s lună', few: 'acum %s luni', other: 'acum %s de luni' },
    w: { one: 'acum %s săptămână', few: 'acum %s săptămâni', other: 'acum %s de săptămâni' },
    d: { one: 'acum %s zi', few: 'acum %s zile', other: 'acum %s de zile' },
    h: { one: 'acum %s oră', few: 'acum %s ore', other: 'acum %s de ore' },
    m: { one: 'acum %s minut', few: 'acum %s minute', other: 'acum %s de minute' },
    s: { one: 'acum %s secundă', few: 'acum %s secunde', other: 'acum %s de secunde' },
  },
  futureLong: {
    y: { one: 'peste %s an', few: 'peste %s ani', other: 'peste %s de ani' },
    M: { one: 'peste %s lună', few: 'peste %s luni', other: 'peste %s de luni' },
    w: { one: 'peste %s săptămână', few: 'peste %s săptămâni', other: 'peste %s de săptămâni' },
    d: { one: 'peste %s zi', few: 'peste %s zile', other: 'peste %s de zile' },
    h: { one: 'peste %s oră', few: 'peste %s ore', other: 'peste %s de ore' },
    m: { one: 'peste %s minut', few: 'peste %s minute', other: 'peste %s de minute' },
    s: { one: 'peste %s secundă', few: 'peste %s secunde', other: 'peste %s de secunde' },
  },
  abbr: {
    y: { one: '%s an', few: '%s ani', other: '%s de ani' },
    M: { one: '%s lună', few: '%s luni', other: '%s de luni' },
    w: { one: '%s săptămână', few: '%s săptămâni', other: '%s de săptămâni' },
    d: { one: '%s zi', few: '%s zile', other: '%s de zile' },
    h: { one: '%s oră', few: '%s ore', other: '%s de ore' },
    m: { one: '%s minut', few: '%s minute', other: '%s de minute' },
    s: { one: '%s secundă', few: '%s secunde', other: '%s de secunde' },
  },
  full: {
    y: { one: '%s an', few: '%s ani', other: '%s de ani' },
    M: { one: '%s lună', few: '%s luni', other: '%s de luni' },
    w: { one: '%s săptămână', few: '%s săptămâni', other: '%s de săptămâni' },
    d: { one: '%s zi', few: '%s zile', other: '%s de zile' },
    h: { one: '%s oră', few: '%s ore', other: '%s de ore' },
    m: { one: '%s minut', few: '%s minute', other: '%s de minute' },
    s: { one: '%s secundă', few: '%s secunde', other: '%s de secunde' },
  },
  justNow: 'chiar acum',
  yesterday: 'Ieri',
  today: 'Azi',
  tomorrow: 'Mâine',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY, H:mm', end: 'D MMM YYYY, H:mm' },
    mt: { start: 'D MMM, H:mm', end: 'D MMM, H:mm' },
    dt: { start: 'D MMM, H:mm', end: 'D MMM, H:mm' },
    t: { start: 'H:mm', end: 'H:mm' },
    'yt+to': { start: 'D MMM YYYY, H:mm', end: 'D MMM YYYY, H:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM, H:mm', end: 'D MMM, H:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM, H:mm', end: 'D MMM, H:mm ([GMT]Z)' },
    't+to': { start: 'H:mm', end: 'H:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'ro';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'a.m.' : 'AM';
    } else {
      return isLowerCase ? 'p.m.' : 'PM';
    }
  },
};
